import styled from '@emotion/styled'

export const UploadReceiptsContainer = styled.div`
  width: 100%;

  .upload_btn {
    width: 100%;
  }
`
